// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Route from "../Route.bs.js";
import * as React from "react";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as StatsConfig from "./StatsConfig.bs.js";
import * as Router from "next/router";
import * as UnitOverview from "./UnitOverview.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function UnitPage(Props) {
  var unitId = Props.unitId;
  var starLevel = Props.starLevel;
  var unitData = Props.unitData;
  var router = Router.useRouter();
  var aperture = ApertureCtx.useValue(undefined);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement("div", {
                        className: "flex-1 sm:w-[576px] md:w-[842px]"
                      }, React.createElement(ContentSection.make, {
                            className: "mb-4",
                            children: React.createElement("div", {
                                  className: "flex items-center"
                                }, React.createElement(UnitImage.make, {
                                      unitId: unitId,
                                      size: 36
                                    }), React.createElement("h4", {
                                      className: "ml-2 font-medium text-2xl"
                                    }, React.createElement(UnitName0.make, {
                                          unit: unitId
                                        })))
                          }), React.createElement(UnitOverview.Inner.make, {
                            unitStats: unitData,
                            starLevel: starLevel,
                            onChangeStarLevel: (function (sl) {
                                if (sl !== starLevel) {
                                  return router.push(Route.toString({
                                                  TAG: /* Stats */0,
                                                  _0: {
                                                    TAG: /* Unit */4,
                                                    unit: unitId,
                                                    starLevel: sl === 0 ? undefined : sl,
                                                    aperture: aperture
                                                  }
                                                }));
                                }
                                
                              })
                          }))
                }));
}

var make = UnitPage;

export {
  make ,
  
}
/* Route Not a pure module */
